export default class DefaultAction {
    action;
    constructor(action) {
        this.action = action;
    }
    run() {
        // eslint-disable-next-line no-console
        console.log(`Default action: ${this.action}`);
    }
}
